import {React, useState, useEffect, useRef} from "react";
import {useHistory, useNavigate} from "react-router-dom";
import emailjs from '@emailjs/browser';

import close_icon from '../images/close_icon.png'

function Property_Form(props){

    const property_enquiry = useRef();

    //ModalToggle
    const showModal = props.open;
    const close = props.close;
    const number = props.number;

    if(showModal === true) {
        document.body.style.overflowY = "hidden"
    } else(document.body.style.overflowY = "scroll");

   
    const property_name = props.property_name;
    const Navigate = useNavigate();

    const initialValues ={
        client_name: "",
        phone: "",
        email: "",
        type: "",
        property: property_name,
        requirements:"",
        
    }

    const[formValues, setFormValues] = useState(initialValues);
    const[formErrors, setFormErrors] = useState({});
    const[isSubmit, setisSubmit]= useState(false);

    useEffect( () =>{
        setFormValues((formValues) => ({
            ...formValues, property: property_name
        }))
    },[property_name]);
    


    function handleChange (e){
        console.log(e.target);
        const{name, value} = e.target;
        setFormValues({...formValues, [name]: value})
    };

    function handleSubmit (e){
        e.preventDefault();
        console.log(`During Submit ${formValues.property}`)
        setFormErrors(validate(formValues));
        if(Object.keys(formErrors).length === 0)
        {setisSubmit(true)};
        console.log(isSubmit);

        if(isSubmit){
            sendEmail();
            console.log("Mail_Sent");
            setTimeout( () => {
                Navigate("/thank-you");
                window.scrollTo(0,0);
                setFormValues(initialValues);
                close();
            },1000) //workaround for "form.reset();"
        }
        
    };

    const sendEmail = () => {
        emailjs
        .sendForm("service_6ynxdw4", "template_cc4xjzu", property_enquiry.current, "hhvaZ8tXKLqxY8JXM")
            .then(() => {
                // alert('Message Sent Successfully')
            }, (error) => {
                console.log(error.text);
                console.log("Something went wrong")
            });
    }

    useEffect( () => {
        if(Object.keys(formErrors).length === 0 && isSubmit){console.log(formValues)
        }
    },[formErrors])

    const validate = (values) =>{
        const errors = {};
        const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

        if(!values.client_name){
            errors.client_name = "Name is requried";
        }

        if(!values.phone){
            errors.phone = "Phone is requried";
        } else if(values.phone.length != "10"){
            errors.phone = "Please enter a valid phone number"
        }

        if(!values.email){
            errors.email = "E-Mail is requried";
        } else if(!regex.test(values.email)){
            errors.email = "This is not a valid email format.";
        };

        if(!values.type){
            errors.type = "Please select a property type"
        };

        // if(!values.willingtobuy){
        //     errors.willingtobuy = "Please select a time period"
        // };
        return errors;

    }


    return(
        <>
        <div className={showModal === true ? "fixed inset-0 flex justify-center items-center bg-black bg-opacity-70 backdrop-blur-sm   z-50 ": "hidden"}>
            <div className="bg-white py-12 px-7 w-full h-[85%] sm:h-fit absolute bottom-0 overflow-scroll  sm:w-[380px] sm:relative rounded-[12px] ">
                
                
                <h1 className="font-[merriweather] text-brown text-center text-[25px] font-bold uppercase leading-[43.5px] mb-5 tracking-[0.75px] ">PROPERTY ENQUIRY </h1>

                <img className="absolute top-5 right-6 w-[25px] cursor-pointer" src={close_icon} alt="Close-Icon" onClick={close} />

                <form ref={property_enquiry} onSubmit={handleSubmit}>
                    <div className="flex flex-col justify-center 5">
                        <label className="modal-label">Name <span className="asterik">*</span></label>
                        <input 
                            className="modal-input" 
                            type="text" 
                            name="client_name" 
                            placeholder="John Doe" 
                            value = {formValues.client_name}
                            onChange = {handleChange}
                        />
                        <p className="font-[Lato] text-[14px] pl-3 text-error-red mt-2">{formErrors.client_name}</p>
                    </div>

                    <div className="flex flex-col justify-center my-5">
                        <label className="modal-label">Phone Number <span className="asterik">*</span></label>
                        <input 
                            className="modal-input" 
                            type="tel" 
                            name="phone" 
                            placeholder="98765-43210" 
                            value = {formValues.phone}
                            onChange = {handleChange}
                        />
                        <p className="font-[Lato] text-[14px] pl-3 text-error-red mt-2">{formErrors.phone}</p>
                    </div>

                    <div className="flex flex-col justify-center my-5">
                        <label className="modal-label">Email <span className="asterik">*</span></label>
                        <input 
                            className="modal-input" 
                            type="email" 
                            name="email" 
                            placeholder="yourname@gmail.com" 
                            value = {formValues.email}
                            onChange = {handleChange}
                        />
                        <p className="font-[Lato] text-[14px] pl-3 text-error-red mt-2">{formErrors.email}</p>
                    </div>

                    <div className="flex flex-col justify-center my-5">
                        <label className="modal-label">Property Type <span className="asterik">*</span></label>
                        <select className="modal-select" name ="type" onChange={handleChange} >
                            <option disabled selected>-Please select one from below-</option>
                            <option value="1 BHK">1 BHK</option>
                            <option value="2 BHK">2 BHK</option>
                            <option value="3 BHK & more">3 BHK & more</option>
                        </select>
                        <p className="font-[Lato] text-[14px] pl-3 text-error-red mt-2">{formErrors.type}</p>
                    </div>

                    <div className="flex flex-col justify-center my-5">
                        <label className="modal-label">Enquiring For</label>
                        {/* <div className="font-[Lato] text-[16px] border-[1px] border-[#D9D9D9] p-[10px] w-full outline-[#FFE000] bg-grey text-font-brown">{property_name}</div> */}
                        <input 
                            className="font-[Lato] text-[16px] border-[1px] border-[#D9D9D9] p-[10px] w-full outline-[#FFE000] bg-grey text-font-brown" 
                            type="text" 
                            name="property" 
                            placeholder= {property_name}                            
                            value = {formValues.property}
                            readOnly
                        />
                    </div>

                    <div className="flex flex-col justify-center my-5">
                        <label className="modal-label">Your Requirement</label>
                        <textarea 
                            className="modal-input" 
                            name="requirements" 
                            type="text" 
                            placeholder="Share your requirements"
                            onChange={handleChange}
                            >
                        </textarea>
                    </div>

                    <button className="bg-yellow w-full p-3  font-[lato] text-14px ">{Object.keys(formErrors).length === 0 && isSubmit ? "Submitting...." : "Submit"}</button>
                </form>
                


            </div>
        </div>
        </>
    )
}


export default Property_Form;